export const QUESTION_REQUEST = 'ASSESSMENT_QUESTION/QUESTION_REQUEST'
export const QUESTION_SUCCESS = 'ASSESSMENT_QUESTION/QUESTION_SUCCESS'
export const QUESTION_ERROR = 'ASSESSMENT_QUESTION/QUESTION_ERROR'

export const FILTER_REQUEST = 'ASSESSMENT_QUESTION/FILTER_REQUEST'
export const FILTER_SUCCESS = 'ASSESSMENT_QUESTION/FILTER_SUCCESS'
export const FILTER_ERROR = 'ASSESSMENT_QUESTION/FILTER_ERROR'

export const DELETE_REQUEST = 'ASSESSMENT_QUESTION/DELETE_REQUEST'
export const DELETE_SUCCESS = 'ASSESSMENT_QUESTION/DELETE_SUCCESS'
export const DELETE_ERROR = 'ASSESSMENT_QUESTION/DELETE_ERROR'
export const CLEAR_DELETE_REQUEST = 'ASSESSMENT_QUESTION/CLEAR_DELETE_REQUEST'
